<template>
  <div class="d-flex">
    <px-alcadas-criterios-card style="width: 47%"
                               :regra="regra"
                               :numero-regra="numeroRegra"
                               :opcoes-criterios="opcoesCriterios"
                               :criterios-enum="criteriosEnum"
                               ref="criterio"/>
    <div style="width: 6%" class="d-flex flex-column justify-center align-center">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="onClickRemove">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Remover regra</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" :disabled="isFirst" @click="onClickMoveUp">
            <v-icon>mdi-chevron-up</v-icon>
          </v-btn>
        </template>
        <span>Mover regra para cima</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" :disabled="isLast" @click="onClickMoveDown">
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <span>Mover regra para baixo</span>
      </v-tooltip>
    </div>
    <px-alcadas-aprovadores-card style="width: 47%"
                                 :regra="regra"
                                 :roles-aprovador="rolesAprovador"
                                 :edicao-sem-aprovacao="edicaoSemAprovacao"
                                 ref="aprovadores" />
  </div>
</template>

<script>
import AlcadasCriteriosCard from '@/modules/alcadas/components/AlcadasCriteriosCard.vue';
import AlcadasAprovadoresCard from '@/modules/alcadas/components/AlcadasAprovadoresCard.vue';

export default {
  props: {
    opcoesCriterios: Array,
    numeroRegra: Number,
    regra: {
      type: Object,
      required: true,
    },
    regras: Array,
    criteriosEnum: Array,
    rolesAprovador: {
      type: Array,
      required: true,
    },
    edicaoSemAprovacao: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isFirst() {
      return this.numeroRegra === 1;
    },
    isLast() {
      return !this.regras || this.numeroRegra === this.regras.length;
    },
  },
  methods: {
    onClickRemove() {
      this.$emit('remove');
    },
    onClickMoveDown() {
      this.$emit('moveDown');
    },
    onClickMoveUp() {
      this.$emit('moveUp');
    },
    isValid() {
      return this.$refs.criterio.isValid() && this.$refs.aprovadores.isValid();
    },
  },
  components: {
    pxAlcadasCriteriosCard: AlcadasCriteriosCard,
    pxAlcadasAprovadoresCard: AlcadasAprovadoresCard,
  },
};
</script>
